import { productAllocationSchema } from './product-allocation.schema';
import { companyTypeSchema } from '../../../schemas/company-type.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const accountLicenseAllocationSchema = z.object({
  alias: z.string(),
  companyName: z.string(),
  externalAccountId: z.string().nullable(),
  externalAccountName: z.string(),
  activationDate: coercedDate,
  expirationDate: coercedDate.nullable(),
  accountType: companyTypeSchema,
  products: z.array(productAllocationSchema),
});

export type AccountLicenseAllocation = z.infer<
  typeof accountLicenseAllocationSchema
>;
